import axios from "axios";

const BASE_URL = "http://216.38.6.193:3001";


// export const invoices = async () => {
//   try {
//     // Simulate fetching data from an API endpoint
//     const response = await axios.get(BASE_URL + "/invoices");

//     // Assuming response.data contains the fetched data from the API
//     const sampleData = [
//       { id: 1, firstName: "Customer 1", lastName: "cust1" },
//       { id: 2, firstName: "Customer 2", lastName: "cust2" },
//       { id: 3, firstName: "Customer 3", lastName: "cust3" },
//       // Add more dummy data as needed
//     ];

//     return sampleData;
//   } catch (error) {
//     console.error("Error fetching customers:", error);
//     throw error;
//   }
// };

export class Invoices {
  
  private static _instance: Invoices;

  private constructor() {}

  public static get instance() {
    
    return this._instance || (this._instance = new this());
  }

  async createInvoice(payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/createInvoice`,
      payload
    );
    return response;
  }

  async recentInvoices (payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/recentInvoices`,
      payload
    );
    return response;
  }

  async saveDraftInvoice (payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/saveDraftInvoice`,
      payload
    );
    return response;
  }

  async listDraftInvoice (payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/listDraftInvoice`,
      payload
    );
    return response;
  }

  async pendingPaymentInvoices(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/pendingPaymentInvoices`,
      payload
    );
    return response;
  }

  async downloadInvoice(payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/downloadInvoice`, payload,
      {
        responseType: 'blob',
      }
    );
    return response;
  }

  async downloadInvoiceCSV(payload: any) {
    const response = await axios.post(`${BASE_URL}/api/quickBooks/downloadInvoiceCsv`, payload, 
      {
        responseType: 'blob'
      }
    );
    return response;
  }

    async invoicesCount(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/invoicesCount`,
      payload
    );
    return response;
  }

  async invoiceDetail(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/getSingleInvoice`,
      payload
    );
    return response;
  }

  async getAllNotes(invoiceId: string) {

    const response = await axios.get(`${BASE_URL}/api/quickBooks/getAllNotes/${invoiceId}`);
    return response;
  }

  async deleteNotes(invoiceId: string) {

    const response = await axios.delete(`${BASE_URL}/api/quickBooks/deleteNotes/${invoiceId}`);
    return response;
  }



  async createNotes(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/createNotes`,
      payload
    );
    return response;
  }

  async sendInvoiceEmail(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/sendInvoice`,
      payload
    );
    return response;
  }

  async getOrderHistory(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/customer_order_history`,
      payload
    );
    return response;
  }

  async inputSearch(payload: any) {

    const response = await axios.post(`${BASE_URL}/api/quickBooks/search_order_docNumber`,
      payload
    );
    return response;
  }

  
}
